import {
  DataTable as MantineDataTable,
  DataTableColumn as MantineDataTableColumn,
  DataTableProps as MantineDataTableProps
} from "mantine-datatable";
import {useMemo} from "react";

export type DataTableColumn<T> = MantineDataTableColumn<T> & {
  // extend props here
}

export type DataTableProps<T> = MantineDataTableProps<T> & {
  // extend props here
}

export function DataTable<T>(props: DataTableProps<T>) {
  const {
    minHeight: defaultMinHeight,
    records,
    ...rest
  } = props;

  const minHeight = useMemo(() => {
    if (!defaultMinHeight && (typeof records === "undefined" || records.length === 0)) {
      return 200;
    } else {
      return defaultMinHeight;
    }
  }, [defaultMinHeight, records]);

  return <MantineDataTable
    {...rest}
    minHeight={minHeight}
    records={records}/>;
}
